import script from "./EmailWarning.vue?vue&type=script&lang=ts&setup=true"
export * from "./EmailWarning.vue?vue&type=script&lang=ts&setup=true"

import "./EmailWarning.vue?vue&type=style&index=0&id=1d4ce38a&lang=sass&setup=true"

const __exports__ = script;

export default __exports__